import React, { useState } from 'react';
import { asset } from '@/lib/api';
import { Construction, Drill, Truck, Tractor, Hammer, Wind, Lightbulb, Zap, Fuel, Droplets, Container, Wrench } from 'lucide-react';

const ICONS = { Construction, Drill, Truck, Tractor, Hammer, Wind, Lightbulb, Zap, Fuel, Droplets, Container, Wrench };

// Shows the authentic equipment photo when one exists; otherwise renders a
// clean, on-brand placeholder panel (category icon + label). When a real image
// is later added at the item's path, it appears automatically — no code change.
export const EquipImage = ({ item, imgClassName = 'h-full w-full object-cover transition-transform duration-[900ms] group-hover:scale-105' }) => {
  const [failed, setFailed] = useState(false);
  const src = item.image ? asset(item.image) : '';
  if (!src || failed) {
    const Icon = ICONS[item.icon] || Wrench;
    return (
      <div className='relative flex h-full w-full flex-col items-center justify-center bg-[#20272A]' data-testid='equip-placeholder'>
        <div className='grain absolute inset-0 opacity-40' />
        <div className='absolute inset-0' style={{ background: 'radial-gradient(circle at 50% 38%, rgba(184,138,59,0.14), transparent 60%)' }} />
        <Icon size={46} strokeWidth={1.4} className='relative text-[#B88A3B]' />
        <span className='relative mt-3 px-5 text-center text-[11px] uppercase tracking-wider text-[#F6F5F1]/45'>{item.category}</span>
      </div>
    );
  }
  return <img src={src} alt={item.name} onError={() => setFailed(true)} className={imgClassName} />;
};
